<!-- Streams -->
@let currentUser = (currentUser$ | async); @let isAdmin = currentUser?.data?.role === 'admin'; @let isOrganization =
currentUser?.data?.role === 'organizationAdmin'; @let isCandidate = currentUser?.data?.role === 'candidate';

<app-autocomplete #auto="appAutocomplete">
  <!-- Option Groups -->
  @if(isAdmin && autocomplete.initialized) {
  <app-autocomplete-option-group>
    <div app-autocomplete-option-group-title>
      <ng-container i18n>Organizations</ng-container>
    </div>
    @for (organization of organizations$ | async | filterBy:'name':autocomplete.searchTerm; track organization.ref.id) {
    <a
      app-autocomplete-option
      [routerLink]="['/organizations', organization.ref.id, 'edit']">
      {{ organization.data.name }}
    </a>
    }
  </app-autocomplete-option-group>
  <app-autocomplete-option-group>
    <div app-autocomplete-option-group-title>
      <ng-container i18n>Candidates</ng-container>
    </div>
    @for (candidate of candidates$ | async | filterBy:['firstName', 'lastName']:autocomplete.searchTerm; track
    candidate.ref.id) {
    <a
      app-autocomplete-option
      [routerLink]="['/candidates', candidate.ref.id, 'edit']">
      {{ candidate | candidate : 'fullName' }}
    </a>
    }
  </app-autocomplete-option-group>
  } @else if(isOrganization && autocomplete.initialized && (organizationId$ | async); as organizationId) {
  <app-autocomplete-option-group>
    <div app-autocomplete-option-group-title>
      <ng-container i18n>Job Postings</ng-container>
    </div>
    @for (jobPosting of organizationJobPostings$ | async | filterBy:'title':autocomplete.searchTerm; track
    jobPosting.ref.id) {
    <a
      app-autocomplete-option
      [routerLink]="['/organizations', organizationId, 'job-postings', jobPosting.ref.id, 'edit']">
      {{ jobPosting.data.title }}
    </a>
    }
  </app-autocomplete-option-group>
  <app-autocomplete-option-group>
    <div app-autocomplete-option-group-title>
      <ng-container i18n>Candidates</ng-container>
    </div>
    @for (jobApplication of organizationJobApplications$ | async; track jobApplication.ref.id) {
    <a
      app-autocomplete-option
      [routerLink]="[
        '/organizations',
        organizationId,
        'job-postings',
        jobApplication.data.jobPostingRef.id,
        'candidates',
        jobApplication.ref.id
      ]">
      <!-- TODO display candidate name -->
      {{ jobApplication.data.candidateRef.id }}
    </a>
    }
  </app-autocomplete-option-group>

  } @else if (isCandidate) {
  <app-autocomplete-option-group>
    <!--
    TODO check if display group title
    <div app-autocomplete-option-group-title>
      <ng-container i18n>Job applications</ng-container>
    </div>
    -->
    @for (jobApplication of candidateJobApplications$ | async; track jobApplication.ref.id) {
    <a
      app-autocomplete-option
      [routerLink]="currentUser ? ['/candidates', currentUser.ref.id, 'applications', jobApplication.ref.id] : null">
      <!-- TODO display job posting name -->
      {{ jobApplication.data.jobPostingRef.id }}
    </a>
    }
  </app-autocomplete-option-group>
  }
  <!-- Default State -->
  <div app-autocomplete-state="default">
    <app-icon
      name="magnifying-glass"
      type="outline">
    </app-icon>
    <p app-autocomplete-state-title>
      @if(isAdmin) {
      <ng-container i18n>Search for organizations and candidates</ng-container>
      } @else if (isOrganization) {
      <ng-container i18n>Search for job postings and candidates</ng-container>
      } @else if (isCandidate) {
      <ng-container i18n>Search for your job applications</ng-container>
      }
    </p>
    <p app-autocomplete-state-subtitle>
      @if(isAdmin) {
      <ng-container i18n>Quickly access organizations and candidates by running a global search.</ng-container>
      } @else if(isOrganization) {
      <ng-container i18n>Quickly access job postings and candidates by running a global search.</ng-container>
      } @else if (isCandidate) {
      <ng-container i18n>Quickly access your job applications by running a global search.</ng-container>
      }
    </p>
  </div>
  <!-- No Results State -->
  <div app-autocomplete-state="no-results">
    <app-icon
      name="face-frown"
      type="outline">
    </app-icon>
    <p app-autocomplete-state-title>
      <ng-container i18n>No results found</ng-container>
    </p>
    <p app-autocomplete-state-subtitle>
      <ng-container i18n>We couldn’t find anything with that term. Please try again.</ng-container>
    </p>
  </div>
</app-autocomplete>
